module.exports = __webpack_public_path__ + "img/thumbnail_SiberianTiger_j_normal.0403cdbb.png";